<template>
  <div :class="['comp-custom-search-ultra', border ? 'has-border' : '', noStyle ? 'no-style' : '']" :style="{ width: `${width}px` }">
    <ly-skeleton v-if="loading" fromType="filter" :highFilter="true"></ly-skeleton>

    <jw-spin v-else :loading="loading" class="rule-form-loading">
      <div class="search-ultra-header" v-if="showHeader">
        <template v-if="data.ruleForm.conditions?.length > 0">
          <div class="search-ultra-header-left">
            <div :class="['search-ultra-header-left-title', headerIsBold ? 'bold' : '']">{{ headerTitle }}</div>
          </div>
          <div class="search-ultra-header-right">
            <div class="search-ultra-header-right-title">
              <jw-button type="text" size="small" class="clear-all-btn hover-btn" @click="clearAllCondition">清空所有</jw-button>
            </div>
          </div>
        </template>
      </div>

      <jw-form class="rule-form" ref="editAddForm" :model="data.ruleForm">
        <div class="search-ultra-wrap" ref="searchUltraWrap" :style="{ maxHeight: `${maxHeight}px` }">
          <template v-for="(item, index) in data.ruleForm.conditions" :key="index">
            <div class="search-ultra-body">
              <jw-row align="start">
                <jw-col :class="index === 0 ? 'condition-title-where' : 'condition-title-where-or'" :span="data.ruleForm.conditions?.length > 1 ? 2 : 0">{{ index === 0 ? outConditionTitle : outMoreConditionTitle }}</jw-col>
                <jw-col :span="data.ruleForm.conditions?.length > 1 ? 22 : 24">
                  <div class="search-inner">
                    <template v-for="(sub, i) in item?.children" :key="i">
                      <jw-row :gutter="4" align="start">
                        <jw-col :span="1" class="condition-title-text" :class="i === 0 ? 'condition-title-where' : 'condition-title-where-or'">{{ i === 0 ? innerConditionTitle : innerMoreConditionTitle }}</jw-col>
                        <jw-col :span="6">
                          <jw-form-item label-col-flex="0" :field="`conditions.${index}.children.${i}.field`" :rules="formItemRules" class="form-field">
                            <jw-select v-model="sub.field" :default-popup-visible="visibleMap[`${index}-${i}`]" @change="changeChild($event, sub, index, i)" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select field-select' }" allow-search allow-clear :dropdown-style="{ width: '200px' }" dropdown-class-name="custom-search-ultra-tree-select">
                              <template v-for="item in allSearchFieldsList" :key="item.value">
                                <fh-divider v-if="item?.isFirstTypeOne"></fh-divider>
                                <jw-option :value="item.value" :title="item.label">
                                  <component :is="getFieldIcn(item)" />
                                  {{ item.label }}
                                </jw-option>
                              </template>
                            </jw-select>
                          </jw-form-item></jw-col
                        >
                        <jw-col :span="checkOperation(sub) ? 16 : 4">
                          <jw-form-item v-show="sub.field" label-col-flex="0" :field="`conditions.${index}.children.${i}.operation`" :rules="formItemRules" class="form-condition">
                            <!-- 企查查特殊处理 -->
                            <jw-select v-if="sub.setting?.fieldKey == 'qccId' || sub.setting?.business?.fieldKey == 'qccId'" class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true, autoFitPopupWidth: false }" @change="changeChildTwo($event, sub)" allow-search>
                              <jw-option v-for="item in data.qccID" :key="item.value" :value="item?.value" :title="item.label">{{ item?.label }}</jw-option>
                            </jw-select>

                            <template v-else>
                              <jw-select class="rule-form-item-sub-filter" v-model="sub.operation" :placeholder="$t('请选择')" :trigger-props="{ updateAtScroll: true, autoFitPopupWidth: false, contentClass: 'search-ultra-filter-select' }" @change="changeChildTwo($event, sub, tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.type)" allow-search>
                                <!-- 条件选择--根据字段类型是24的特殊处理（根据fieldExt中的type再区分条件） -->
                                <template v-if="sub.setting?.fieldType == 24 || sub.setting?.business?.fieldType == 24">
                                  <jw-option v-for="item in getConditionFilterType(sub)" :key="item.value" :value="item?.value" :title="item.label">{{ item?.label }}</jw-option>
                                </template>
                                <template v-else>
                                  <jw-option :title="item.label" v-for="item in getOperations(sub)" :key="item.value" :value="item?.value">{{ item?.label }}</jw-option>
                                  <!-- 特殊处理属于当前值 -->
                                  <jw-option :title="item.label" v-if="getFindAssociation(sub)" :value="findAssociation.value">{{ findAssociation.label }}</jw-option>
                                </template>
                              </jw-select>
                            </template>
                          </jw-form-item>
                        </jw-col>
                        <jw-col :span="!checkOperation(sub) ? 12 : 0">
                          <jw-form-item v-show="sub.field" class="form-value" v-if="sub.operation != 'null' && sub.operation != 'not_null' && sub.operation != 'equals_current_value'" label-col-flex="0" :field="`conditions.${index}.children.${i}.value`" :rules="formItemRules">
                            <!--单选 下拉单选 多选 下拉多选 -->

                            <template v-if="checkSelectFieldType(sub)">
                              <fh-select @change="changeLastChild($event, sub.field)" :multiple="checkMultiple(sub)" v-model.trim="sub.value" :placeholder="$t('请选择')" class="item-fh-select" :max-tag-count="2" :options="getSelectOption(sub)">
                                <template #label="{ data }">
                                  <ly-show-filters showType="condition" :showInner="data.label" />
                                </template>
                              </fh-select>

                              <!-- <jw-select @change="changeLastChild($event, sub.field)" :multiple="checkMultiple(sub)" v-model.trim="sub.value" :placeholder="$t('请选择')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true, contentClass: 'search-ultra-filter-select' }" allow-clear allow-search :max-tag-count="2">
                                <template #label="{ data }">
                                  <ly-show-filters showType="condition" :showInner="data.label" />
                                </template>
                                <jw-option v-for="item in getSelectOption(sub)" :key="item.value" :title="item.label" :value="item.value" :disabled="!item.isEnabled">{{ item.label }} </jw-option>
                              </jw-select> -->
                            </template>

                            <!-- 人员类型 -->
                            <template v-else-if="sub?.setting?.fieldType == 6 || sub?.setting?.business?.fieldType == 6">
                              <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                                <fh-person :multiple="sub.operation === 'equals' || sub.operation === 'not_equals' ? false : true" :isError="personError[`${index}-${i}`]" :maxTagCount="2" :item="sub" @cb="getUserDeptValue($event, index, i)"> </fh-person>
                              </template>
                            </template>

                            <!-- 数字类型 -->
                            <template v-else-if="[7].includes(sub.setting?.fieldType || sub.setting?.business?.fieldTyp) && sub.operation != 'null' && sub.operation != 'not_null'">
                              <jw-input-number v-if="sub.operation != 'null' && sub.operation != 'not_null'" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum)" :placeholder="$t('请选择')" />
                            </template>

                            <!-- 日期类型 -->
                            <template v-else-if="sub.setting?.fieldType == 8 || sub.setting?.business?.fieldType == 8 || sub.setting?.subProperty">
                              <!-- 特殊：目前计算字段中（汇总类的数据范围）没有用日期变量，所以将其排除在外 -->
                              <template v-if="dateHasRang">
                                <xl-date-variable :canSelectMore="canSelectMore" tagClassName="date-tag-input" :objList="sub.setting" :record="sub" @cb="getDateVariable($event, index, i)" />
                              </template>

                              <template v-else>
                                <jw-date-picker @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt)?.dataType : sub.setting?.fieldExt" v-if="sub.operation != 'between' && sub.operation != 'null' && sub.operation != 'not_null'" :placeholder="$t('请选择日期范围')" :show-time="isShowTime(sub)" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                                <jw-range-picker type="time-range" @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" v-else-if="sub.operation == 'between'" :show-time="isShowTime(sub)" :format="tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt)?.dataType : sub.setting?.fieldExt" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                              </template>
                            </template>

                            <!-- 日期范围 -->
                            <template v-else-if="sub.setting?.fieldType == 9 || sub.setting?.business?.fieldType == 9">
                              <jw-range-picker @change="changeLastChild($event, sub.field)" v-if="sub.setting?.fieldExt == '0' || sub.setting?.business?.fieldExt == '0'" v-model="sub.value" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" />
                              <jw-range-picker @change="changeLastChild($event, sub.field)" v-else-if="sub.setting?.fieldExt == '1' || sub.setting?.business?.fieldExt == '1'" class="rule-form-item-sub-select" v-model="sub.value" @select="onSelect" :disabledDate="(current) => dayjs(current).isAfter(dayjs())" :trigger-props="{ updateAtScroll: true }" />
                              <jw-range-picker @change="changeLastChild($event, sub.field)" v-else v-model="sub.value" class="rule-form-item-sub-select" @select="onSelect" :disabledDate="(current) => dayjs(current).isBefore(dayjs(new Date().getTime() - 24 * 60 * 60 * 1000))" :trigger-props="{ updateAtScroll: true }" />
                            </template>

                            <!-- 级联类型 -->

                            <template v-else-if="sub.setting?.fieldType == 10 || sub.setting?.business?.fieldType == 10">
                              <jw-cascader :trigger-props="{ updateAtScroll: true }" :max-tag-count="1" :tag-nowrap="true" :path-mode="true" class="rule-form-item-sub-select" :options="getCascaderExt(sub)" allow-search v-model="sub.value" @change="changeLastChild($event, sub.field)" :placeholder="$t('请选择')" :multiple="sub.operation == 'in' || sub.operation == 'not_in'">
                                <template #label="{ data }">
                                  <ly-show-filters showType="condition" :showInner="data.label" />
                                </template>
                              </jw-cascader>
                            </template>

                            <!-- 金额类型 -->
                            <template v-else-if="sub.setting?.fieldType == 16 || sub.setting?.business?.fieldType == 16">
                              <template v-if="(sub.operation !== 'null' && sub.operation !== 'not_null') || sub.operation === ''">
                                <template v-if="isFormat">
                                  <jw-input-number v-model="sub.value" :placeholder="$t('请选择')" :precision="getPrecision(sub, precisionNum)" class="rule-form-item-sub-select" :ref="(el) => (inputRefs[sub.field] = el)" @blur="amountBlur" @change="changeLastChild($event, sub.field)" @input="(event) => getPrecisionNum(event, sub)" />
                                </template>
                                <template v-else>
                                  <jw-input-number v-model="sub.value" :ref="(el) => (inputRefs[sub.field] = el)" :placeholder="$t('请选择')" :precision="getPrecision(sub, precisionNum)" class="rule-form-item-sub-select" @focus="amountFocus(sub.field)" @change="changeLastChild($event, sub.field)" @input="(event) => getPrecisionNum(event, sub)" :formatter="(val) => isShowThousandFormatter(val, sub)" :parser="(val) => val.replace(/,/g, '')" />
                                </template>
                              </template>
                            </template>

                            <!-- 部门类型 -->
                            <template v-else-if="sub.setting?.fieldType == 22 || sub.setting?.business?.fieldType == 22">
                              <template v-if="(sub.operation != 'null' && sub.operation != 'not_null') || sub.operation == ''">
                                <xl-user-depart :maxTagCount="2" @cb="getUserDeptValue($event, index, i)" :isScreen="true" :tree="departTree" style="width: 100%" :sub="sub"></xl-user-depart>
                              </template>
                            </template>

                            <!-- 百分比 -->
                            <template v-else-if="sub.setting?.fieldType == 23 || sub.setting?.business?.fieldType == 23">
                              <jw-input-number v-if="sub.operation != 'null' && sub.operation != 'not_null'" @change="changeLastChild($event, sub.field)" @input="(event) => getPrecisionNum(event, sub)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" :precision="getPrecision(sub, precisionNum)">
                                <template #append> % </template>
                              </jw-input-number>
                            </template>

                            <!-- 计算字段 -->
                            <template v-else-if="(sub.setting?.fieldType == 24 || sub.setting?.business?.fieldType == 24) && sub.operation != 'null' && sub.operation != 'not_null'">
                              <!-- 计算字段的fieldExt的type=5 :数字（汇总累计）type=7 :数字-->
                              <template v-if="getConditionType(sub, [5, 7])">
                                <jw-input-number @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum, true)" />
                              </template>
                              <!-- 计算字段的fieldExt的type=6 :金额(汇总金额) type=16 :金额 -->
                              <template v-else-if="getConditionType(sub, [6, 16])">
                                <jw-input-number @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :formatter="(event) => isShowThousandFormatter(event, sub)" :parser="(value) => value.replace(/,/g, '')" :precision="getPrecision(sub, precisionNum, true)" />
                              </template>
                              <!-- 计算字段的fieldExt的type=0 :文本 -->
                              <template v-else-if="getConditionType(sub, [0])">
                                <jw-input maxLength="200" show-word-limit v-model.trim="sub.value" :placeholder="$t('请输入')" @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" />
                              </template>
                              <!-- 计算字段的fieldExt的type=23 :百分比 -->
                              <template v-else-if="getConditionType(sub, [23])">
                                <jw-input-number @change="changeLastChild($event, sub.field)" class="rule-form-item-sub-select" v-model="sub.value" :placeholder="$t('请选择')" @input="(event) => getPrecisionNum(event, sub)" :precision="getPrecision(sub, precisionNum, true)">
                                  <template #append> % </template>
                                </jw-input-number>
                              </template>
                              <!-- 计算字段的fieldExt的type=8 :日期 -->
                              <template v-else-if="getConditionType(sub, [8])">
                                <jw-date-picker @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="getCmpPermisson(sub)" v-if="sub.operation != 'between'" :placeholder="$t('请选择日期范围')" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                                <jw-range-picker type="time-range" @change="changeLastChild($event, sub.field, branchIndex)" v-model="sub.value" :format="getCmpPermisson(sub)" v-else-if="sub.operation == 'between'" class="rule-form-item-sub-select" :trigger-props="{ updateAtScroll: true }" position="br" />
                              </template>
                            </template>

                            <!-- 单行文本 -->
                            <template v-else>
                              <jw-input v-qfeiTrim maxLength="200" show-word-limit v-model="sub.value" :input-attrs="{ type: 'search' }" :name="'conditionschildren'" :field="`conditions.${index}.children.${i}.value`" :placeholder="$t('请输入')" @change="changeLastChild($event, sub)" class="rule-form-item-sub-select" />
                            </template>
                          </jw-form-item>
                        </jw-col>
                        <jw-col :span="1" :style="{ padding: '0' }" class="delete-icon-wrap">
                          <span class="handle-icon delete-icon"><icon-delete @click="conditionUpdate(1, index, i)" :size="16" /></span>
                        </jw-col>
                      </jw-row>
                    </template>
                    <div class="add-condition">
                      <jw-button size="small" class="add-condition-btn hover-btn" type="text" @click="conditionUpdate(1, index)">
                        <template #icon>
                          <icon-plus />
                        </template>
                        添加条件
                      </jw-button>
                      <jw-button size="small" v-if="item?.children?.length > 1" class="clear-group hover-btn" type="text" @click="conditionUpdate(0, index)"> 清除组 </jw-button>
                    </div>
                  </div>
                </jw-col>
              </jw-row>
            </div>
          </template>
        </div>
      </jw-form>

      <div :class="['search-ultra-footer', data.ruleForm.conditions?.length > 0 ? '' : 'empty']">
        <div class="footer-left">
          <jw-button type="text" size="small" class="add-group" @click="conditionUpdate(0)">
            <template #icon>
              <icon-plus />
            </template>
            添加条件组
          </jw-button>
        </div>
        <div class="search-ultra-footer" v-if="showFooter">
          <jw-space>
            <slot name="btn"></slot>
            <jw-button class="btn-submit" size="small" type="primary" @click="searchSubmit">确认</jw-button>
          </jw-space>
        </div>
      </div>
    </jw-spin>
  </div>
</template>

<script setup>
import _ from 'lodash';

import { reactive, ref, watch, inject, computed, nextTick } from 'vue';
import { Message } from '@arco-design/web-vue';
import dayjs from 'dayjs';

import { useUserStore, useConditionStore } from '@/store';
import { setService, biService } from '@/api/';
import { tools } from '@/utils/tools';
import useLoading from '@/hooks/loading';
import useFields from '@/hooks/fields';
import useThousandOption from '@/hooks/thousand';
import { useI18n } from 'vue-i18n';
import fhDivider from '@/components/fh-divider/fh-divider.vue';
import FhSelect from '@/components/fh-select/fh-select.vue';
import { useGrayscaleStore } from '@/store';

const { grayList } = useGrayscaleStore();
const { moveTypeOneToEnd } = useFields();

// 计算字段汇总类型灰度控制
const canSelectMore = computed(() => {
  if (props.needCheckGays) {
    // 如果需要检查灰度，则返回灰度配置
    if (grayList?.['COMPUTE:SUM:DATE']) {
      return true;
    }
    return false;
  }
  return true;
});

const { loading, setLoading } = useLoading(false);
const isFormat = ref(false); // 金额焦点
const inputRefs = ref({});
const amountFocus = (field) => {
  isFormat.value = true;
  nextTick(() => {
    inputRefs.value[field]?.focus();
  });
};
const amountBlur = () => {
  isFormat.value = false;
};

const { userInfo } = useUserStore(); //用户信息
const { t } = useI18n();
// 精度
// 处理精度 千分符
const { precisionNum, isShowThousandFormatter, getPrecisionNum, getPrecision } = useThousandOption();

const emits = defineEmits(['cb', 'setCondition', 'submit', 'clearAll']);
const editAddForm = ref();

const objectFormDataMethods = inject('objectFormDataMethods'); //调用父组件方法(新增字段时数据范围来源（查找关联，编码)
const conditionStore = useConditionStore();

const findAssociation = { label: t('属于当前值'), value: 'equals_current_value' };

const formItemRules = [{ required: true, message: t('请选择') }];
const { fieldIconMapping } = useFields(); // 获取字段图标

const getFieldIcn = (field) => {
  return fieldIconMapping.value[Number(field.fieldType)];
};

const gettempSettingIds =
  objectFormDataMethods?.gettempSettingIds ||
  (() => {
    return '';
  }); //获取布局新增的字段 但是布局并没有保存字段信息
// 获取本次布局禁用的字段信息
const gettempDisableSettingIds =
  objectFormDataMethods?.gettempDisableSettingIds ||
  (() => {
    return '';
  });

const props = defineProps({
  showLabel: {
    type: Boolean,
    default: false
  },
  entity: {
    type: Number,
    default: 0
  },
  parentEntityId: {
    type: Number,
    default: null
  },
  conditions: {
    type: Array,
    default: () => []
  },
  isCascadingMultiple: {
    type: Boolean,
    default: false
  },
  dateHasRang: {
    type: Boolean,
    default: true
  },

  chartId: {
    type: Number,
    default: null
  },
  ruleOutFieldKeys: {
    type: Array,
    default: () => []
  },
  roleOutFieldTypes: {
    type: Array,
    default: () => []
  },
  showDefaultCondition: {
    type: Boolean,
    default: false
  },
  maxHeight: {
    type: Number,
    default: 300
  },
  showHeader: {
    type: Boolean,
    default: true
  },
  headerTitle: {
    type: String,
    default: '高级筛选'
  },

  showFooter: {
    type: Boolean,
    default: true
  },
  width: {
    type: Number
  },
  border: {
    type: Boolean,
    default: false
  },
  noStyle: {
    type: Boolean,
    default: false
  },
  headerIsBold: {
    type: Boolean,
    default: false
  },
  needSplitDateRange: {
    type: Boolean,
    default: false // 是否需要拆分日期范围，目标只有列表拆分
  },
  needCheckGays: {
    // 是否需要检查灰度，计算字段汇总条件是否需要检查灰度
    type: Boolean,
    default: false
  }
});

console.log(props);
const entityId = computed(() => props.entity);
const conditionsData = computed(() => props.conditions);
const searchUltraWrap = ref(); // 搜索条件容器
const isFirstFlag = ref(false);

const innerConditionTitle = ref('当');
const innerMoreConditionTitle = ref('且');

const outConditionTitle = ref('满足');
const outMoreConditionTitle = ref('或');

const allSearchFieldsList = ref([]); // 所有字段列表

const data = reactive({
  orgId: userInfo?.orgId, //组织id
  ruleForm: {
    fieldKey: t('全部数据'), //数据条件
    leadsFieldList: [], //字段列表
    filterType: {}, // 运算符集合
    isGroup: true,
    field: null,
    value: null,
    parentId: undefined,
    conditions: []
  },
  lastEntityId: '',
  qccID: [
    {
      label: '为空',
      value: 'null',
      business: null,
      deleted: null
    },
    {
      label: '不为空',
      value: 'not_null',
      business: null,
      deleted: null
    }
  ]
});
const name = ref();
// 控制弹窗的显示
const visibleMap = ref({});

// 获取计算字段后缀
const getCmpPermisson = (sub) => {
  if (sub.setting?.fieldType === 21) {
    return tools.isJSON(sub.setting?.business?.fieldExt) ? Number(JSON.parse(sub.setting?.business?.fieldExt)?.dataType) : null;
  }
  return tools.isJSON(sub.setting?.fieldExt) ? Number(JSON.parse(sub.setting?.fieldExt)?.dataType) : null;
};

//级联获取ext
const getCascaderExt = (sub) => {
  const extInfo = sub.setting?.fieldType != 21 ? sub.setting?.fieldExt : sub.setting?.business?.fieldExt;
  return tools.isJSON(extInfo) ? JSON.parse(extInfo) : null;
};

// 判断宽度
const checkOperation = (sub) => {
  return sub.operation === 'null' || sub.operation === 'not_null' || sub.operation === 'equals_current_value';
};

// 计算字段的判断条件
const getConditionType = (sub, type) => {
  const isFieldExtJSON = tools.isJSON(sub.setting?.fieldExt);
  const isBusinessFieldExtJSON = tools.isJSON(sub.setting?.business?.fieldExt);
  let shouldRender = false;
  if (isFieldExtJSON || isBusinessFieldExtJSON) {
    const fieldExtType = isFieldExtJSON ? JSON.parse(sub.setting?.fieldExt)?.type : null;
    const businessFieldExtType = isBusinessFieldExtJSON ? JSON.parse(sub.setting?.business?.fieldExt)?.type : null;

    const isTypeValid = type.includes(fieldExtType) || type.includes(businessFieldExtType);
    const isOperationValid = sub.operation !== 'null' && sub.operation !== 'not_null';

    shouldRender = isTypeValid && isOperationValid;
  }

  return shouldRender;
};

// 判断下拉类型选项个数
const getSelectOption = (sub) => {
  if (Number(sub.setting?.fieldType) === 21) {
    return tools.isJSON(sub.setting?.business?.fieldExt) ? JSON.parse(sub.setting?.business?.fieldExt) : null;
  }
  return tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt) : null;
};

// 判断字段类型

const checkSelectFieldType = (sub) => {
  const selectTypes = [2, 4, 3, 5];
  return selectTypes.includes(sub.setting?.fieldType) || selectTypes.includes(sub.setting?.business?.fieldType);
};

// 判断是否多选
const checkMultiple = (sub) => {
  return sub.operation == 'equals' || sub.operation == 'not_equals' || sub.operation == '' ? false : true;
};

// 获取属于当前值
const getFindAssociation = (sub) => {
  return (sub.setting?.fieldType == 12 || sub.setting?.fieldType == 25) && sub.setting?.fieldExt == props.parentEntityId;
};

// 获取运算符
const getOperations = (sub) => {
  const isCasecadeField = !props.isCascadingMultiple && (sub.setting?.fieldType == 10 || sub.setting?.business?.fieldType == 10);

  if (isCasecadeField) {
    return data.ruleForm?.filterType[10]?.filter((v) => v.value !== 'in' && v.value !== 'not_in');
  }

  // 获取字段类型
  const fieldType = sub.setting?.fieldType != 21 ? sub.setting?.fieldType : sub.setting?.business?.fieldType;
  //日期范围拆分字段特殊处理
  const checkFieldType = sub.setting?.subProperty ? 8 : fieldType;
  // 获取基础选项
  const baseOptions = data.ruleForm?.filterType[checkFieldType] || [];

  return baseOptions;
};

// 日期类型获取日期变量
const getDateVariable = (record, index, i) => {
  data.ruleForm.conditions[index].children[i].value = record;
  if (record) emits('cb', updateCondition());
};

// 人员选择
const getUserDeptValue = (v, index, i) => {
  // debugger;
  const userNames = computed(() => v?.userList?.map((u) => u.userName));
  const departNames = computed(() => v?.departList?.map((u) => u.departmentName));
  const ud = data.ruleForm.conditions[index].children[i];
  ud.userDept = [...userNames.value, ...departNames.value];
  ud.userList = v.userList;
  ud.departList = v.departList;
  const userIds = ud.userList?.map((c) => c.id);
  const departIds = ud.departList?.map((c) => c.id);

  if (userIds.length === 0 && departIds.length === 0) {
    // 人员 部门全部为空
    ud.value = null;
    return;
  }

  ud.value = JSON.stringify({
    userIds,
    departIds
  });
  if (ud.operation === 'equals' || ud.operation == 'not_equals') {
    if (ud.userDept.length > 1) {
      Message.warning(t('请注意，只可选择一个人员或部门哦'));
    }
  }
  personError.value[`${index}-${i}`] = false;

  emits('cb', updateCondition());
};

// 获取显示的名称
// const getFieldName = (value) => {
//   const getItem = data.ruleForm.leadsFieldList?.find((el) => {
//     // 检查当前项是否直接匹配
//     if (el.subFieldKey === value) {
//       return el; // 返回 true 表示当前项匹配
//     }
//     // 检查子设置中是否有匹配项
//     if (el?.childSetting && el.childSetting.find((item) => item.subFieldKey === value)) {
//       return el; // 返回 true 表示子设置中有匹配项
//     }
//     // 如果当前项或子设置中都没有匹配项，则返回 false
//     return undefined;
//   });
//   console.log(360, getItem);
//   if (getItem?.fieldType == 27) {
//     const childFieldName = getItem?.childSetting?.find((item) => item.subFieldKey === value)?.setFieldName;
//     return childFieldName || '';
//   } else {
//     return getItem?.setFieldName || '';
//   }
// };

// 获取ext信息
const getExtInfo = async (sub) => {
  const fieldExtData = await setService.sysEntityfieldExt({ settingId: sub.setting?.id, apiIndex: Math.random() });
  if (!fieldExtData.error) {
    return fieldExtData?.result;
  } else {
    return null;
  }
};

// 滚动到最底部
const scrollToBottom = () => {
  nextTick(() => {
    if (searchUltraWrap.value) {
      searchUltraWrap.value.scrollTo({
        top: searchUltraWrap.value?.scrollHeight,
        behavior: 'smooth'
      });
    }
  });
};

// 更新条件
const conditionUpdate = (tp, index, i) => {
  console.log('tp, index, i', tp, index, i);
  if (tp) {
    // 子级
    if (i === undefined) {
      data.ruleForm.conditions[index].children?.push({ id: undefined, parentId: undefined, field: '', fieldType: '', operation: '', value: null, isGroup: false });

      const len = data.ruleForm.conditions[index].children?.length;
      visibleMap.value[`${index}-${len - 1}`] = true;

      // 滚动到最底部
      if (index === data.ruleForm.conditions.length - 1) {
        scrollToBottom();
      }
    } else {
      data.ruleForm.conditions[index].children?.splice(i, 1);
      if (!data.ruleForm.conditions[index]?.children?.length) {
        data.ruleForm.conditions?.splice(index, 1);
      }
      visibleMap.value = {};
      emits('cb', updateCondition());
    }
  } else {
    // 父级
    if (index === undefined) {
      data.ruleForm.conditions?.push({ id: undefined, parentId: undefined, operation: 'and', field: '', fieldType: '', value: null, isGroup: true, children: [{ id: undefined, parentId: undefined, field: props?.fieldKey || '', fieldType: '', operation: '', value: null, isGroup: false }] });
      const len = data.ruleForm.conditions?.length;
      visibleMap.value[`${len - 1}-0`] = true;
      scrollToBottom();
    } else {
      data.ruleForm.conditions?.splice(index, 1);
      visibleMap.value = {};
      emits('cb', updateCondition());
    }
  }

  // 滚动到最底部

  condition();
};

const updateCondition = () => {
  const arr = JSON.parse(JSON.stringify(data.ruleForm.conditions));
  arr?.forEach((item) => {
    item.children?.forEach((child) => {
      child.fieldType = child.setting?.fieldType;
      const childField = child.field?.split('.');

      if (childField?.length == 2) {
        //说明是子表单
        child.field = child.field?.split('.')[0];

        const subDateField = child.subProperty ? child.setting?.fieldKey?.split('-')[0]?.split('.')[1] : child.setting?.fieldKey;

        child['remark'] = JSON.stringify({ entity: child.setting.entityId, fieldKey: subDateField, settingId: child.setting.id });
      }

      if (child.field?.split('-')?.length == 2) {
        //说明是日期范围
        child.field = child.field?.split('-')[0];
      }

      if (Array.isArray(child.value) && (child.operation === 'in' || child.operation === 'not_in')) {
        if (Array.isArray(child.value[0]) && isCascader(child)) {
          child.value = child.value?.map((subArr) => subArr?.join('/'))?.join(',');
        } else {
          if (Array.isArray(child.value)) {
            child.value = child.value?.filter(Boolean)?.join(',');
          }
        }
      } else if (Array.isArray(child.value) && child.operation === 'between') {
        //只有日期，日期范围有'between'操作符
        const obj = {
          beginDate: child.value[0],
          endDate: child.value[1]
        };
        const jsonObj = JSON.stringify(obj);
        child.value = jsonObj;
      } else if ((Array.isArray(child.value) && child.operation == 'equals') || child.operation == 'not_equals') {
        if (isCascader(child) && Array.isArray(child.value)) {
          child.value = child.value?.join('/');
        }
      }
      if (isPrice(child) && child.operation != 'null' && child.operation != 'not_null') {
        child.value = child.value * 10000;
      }
      if (isNumber(child) && child.operation != 'null' && child.operation != 'not_null') {
        if (child.value || child.value === 0) {
          child.value = Number(child.value);
        }
      }
      // 处理百分比字段类型
      if (isPercentage(child) && child.operation != 'null' && child.operation != 'not_null') {
        if (child.value && !isNaN(Number(child.value))) {
          let fieldExt = '';
          if (child.setting.fieldType === 21) {
            if (child.setting?.business.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.business?.fieldExt) && JSON.parse(child.setting?.business?.fieldExt)?.numberFormat) || 2;
            }
          } else {
            if (child.setting.fieldType === 24) {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.dataType) || 2;
            } else {
              fieldExt = (tools.isJSON(child.setting?.fieldExt) && JSON.parse(child.setting?.fieldExt)?.numberFormat) || 2;
            }
          }
          child.value = tools.setPercentage(child.value, fieldExt);
        }
      }
      // 处理人员字段类型
      if (isUserDepartment(child)) {
        if ((child.operation != 'null' || child.operation != 'not_null') && _.isObject(child.value)) {
          child.value = JSON.stringify({
            userIds: _.map(child.value.userIds, 'id'),
            departIds: _.map(child.value.departIds, 'id')
          });
        }
        if (props.chartId && child?.userList?.length > 0) {
          //图表
          if (child?.business === null) child.business = {};
          child.business['userIds'] = child.userList?.map((v) => {
            return {
              ...v,
              name: v.userName,
              avatar: v.avatarOrigin
            };
          });
        }
      }
    });
  });
  arr?.forEach((item) => {
    if (item.children) {
      item.children?.forEach((child) => {
        console.log(960, child);
        if (child.setting) delete child.setting;
        // child.remark= subField ? JSON.stringify({ entity: entity, fieldKey: field, settingId: settingId }) : ''
      });
    }
  });

  return arr;
};

// 获取条件下拉选择
const getConditionFilterType = (sub) => {
  let list = [];
  const fieldType = sub?.setting?.fieldType;
  const drf = data.ruleForm?.filterType;
  console.log('计算字段运算符', JSON.parse(JSON.stringify(sub)));

  if (fieldType == 21) {
    // 引用字段
    if (sub.setting?.business?.fieldType == 24) {
      // 计算字段
      const businessFieldExt = tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt);
      list = drf?.[sub.setting?.business?.fieldType]?.[businessFieldExt?.type];
    } else {
      // 非计算字段
      list = drf?.[sub.setting?.business?.fieldType];
    }
  } else {
    // 非引用字段
    if (fieldType == 24) {
      // 计算字段
      const fieldExt = tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt);

      list = drf?.[fieldType]?.[fieldExt?.type];
    } else if (fieldType == 9 && sub.setting?.subProperty) {
      // 日期范围 开始时间/结束时间
      list = drf?.[8];
    } else {
      // 非计算字段
      list = drf?.[sub.setting?.fieldType];
    }
  }
  return list;
};

// 第一个框change事件
const changeChild = async (e, sub, index, i) => {
  sub.loading = true;
  addFieldSetting(data.ruleForm.conditions[index].children[i]);
  sub.operation = '';
  sub.value = null;
  sub.business = [];
  sub.userDept = [];
  sub.userDeptIds = [];
  sub.departList = [];
  sub.userList = [];
  sub.remark = null;
  sub.fieldType = sub?.setting?.fieldType;
  sub.subProperty = sub?.setting?.subProperty;
  sub.field = e;
  sub.isExpand = false;
  //获取ext信息
  const fieldExtData = await getExtInfo(sub);
  if (fieldExtData) {
    if (sub?.setting?.fieldType == 21) {
      sub.setting.business = fieldExtData?.business;
      sub.setting.fieldExt = fieldExtData?.fieldExt;
    } else {
      sub.setting.fieldExt = fieldExtData?.fieldExt;
    }
  }
  sub.loading = false;
  data.fieldThree = '';

  if (e) {
    // 设置默认的 operation 值
    const fieldType = sub.setting?.fieldType != 21 ? sub.setting?.fieldType : sub.setting?.business?.fieldType;

    const checkFieldType = sub.setting?.subProperty ? 8 : fieldType;

    const operations = data.ruleForm?.filterType[checkFieldType]; // 可用的运算符
    // 如果是计算字段（24），需要特殊处理
    if (fieldType === 24) {
      const fieldExt = tools.isJSON(sub.setting?.fieldExt) ? JSON.parse(sub.setting?.fieldExt) : null;
      const type = fieldExt?.type;
      if (type && operations?.[type]?.length > 0) {
        sub.operation = operations[type][0].value;
      }
    }

    if (sub.field === 'qccId') {
      //企查查特殊处理
      const qccOptions = data.qccID[fieldType]; // 可用的运算符
      console.log('第一次变更', sub, qccOptions);
      sub.operation = qccOptions.value;
    }

    if (fieldType === 10) {
      // 级联字段需要过滤多选的选项
      const enabledOptions = operations.filter((o) => !['in', 'not_in'].includes(o.value));
      sub.operation = enabledOptions[0].value;
    } else if (Array.isArray(operations) && operations.length > 0) {
      sub.operation = operations[0].value;
    }

    console.log('第一次变更', sub, operations, data.qccID[fieldType]);
  }
  await condition();
};

// 第二个框change事件
const changeChildTwo = (e, sub, type) => {
  console.log('changeChildTwo', e, sub, type);
  sub.value = '';
  // 清空部门、用户、角色
  if (sub?.userDept || sub?.departList || sub?.userList) {
    sub.userDept = [];
    sub.userDeptIds = [];
    sub.departList = [];
    sub.userList = [];
  }

  const arr = Object.values(data.ruleForm.filterType);
  arr?.forEach((item) => {
    // 对计算字段24的条件进行特殊处理
    item = Array.isArray(item) ? item : item[type];
    item?.forEach((i) => {
      if (i.value == e) {
        data.fieldTwo = i.label;
      }
    });
  });
  condition();
  if (e == 'null' || e == 'not_null') emits('cb', updateCondition());
};

//最后框
const changeLastChild = (e, sub) => {
  console.log('lastChange', e, sub);
  if (Array.isArray(e)) {
    data.fieldThree = e[0] ?? '';
  } else {
    data.fieldThree = e ?? '';
  }
  condition();
  console.log('changeLastChild', sub);
  emits('cb', updateCondition());
};

//过滤树节点
// const filterTreeNode = (searchValue, nodeData) => {
//   if (nodeData?.fieldType == 27) {
//     //子表单
//     return nodeData?.childSetting?.find((el) => el?.fieldName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1);
//   } else {
//     return nodeData.fieldName.toLowerCase().indexOf(searchValue.toLowerCase()) > -1;
//   }
// };

const filterStatus = (item) => {
  if (item.fieldType == '4' && item.fieldKey == 'status' && tools.isJSON(item.fieldExt)) {
    const fieldExtArray = JSON.parse(item.fieldExt)?.filter((e) => e.value != '4');
    item.fieldExt = JSON.stringify(fieldExtArray);
  }
};

// 获取字段类型条件

const dateRangStart = '@@@@start'; // 日期范围开始时间
const dateRangEnd = '@@@@end'; // 日期范围结束时间

const getFieldTypeCondition = async () => {
  try {
    const json = await setService.getDynamic({ apiIndex: Math.random() });
    console.log('json', json);
    if (!json.error) {
      json.result?.forEach((item) => {
        if (item.fieldType == 24) {
          data.ruleForm.filterType[item.fieldType] = item.computeMaps; //第二个框
        } else {
          data.ruleForm.filterType[item.fieldType] = item.conditions; //第二个框
        }
      });
      if (props.parentEntityId) {
        data.qccID.push(findAssociation);
      }
    }
  } catch (error) {
    console.log(error);
  }
  //缓存本次更新的entityId
  data.lastEntityId = entityId.value;
};

// 替换 isEnabled 为 disabled
const replaceIsEnabled = (fieldExt) => {
  return fieldExt?.replace('"isEnabled":true', '"disabled":false').replace('"isEnabled":false', '"disabled":true');
};

// 过滤字段类型
const filterFieldTypes = (fieldList, filterTypes) => {
  return fieldList?.filter((v) => !filterTypes.includes(v.fieldType)) || [];
};

const handleFieldList = async (fieldList) => {
  const { roleOutFieldTypes, isFilterDateRange } = props;
  // 默认字段过滤
  if (roleOutFieldTypes.length) {
    data.ruleForm.leadsFieldList = filterFieldTypes(fieldList, roleOutFieldTypes);

    // 图表类型特殊处理
    if (props.chartId) {
      data.ruleForm.leadsFieldList = filterFieldTypes(fieldList?.fields, roleOutFieldTypes);
    }
  } else {
    // 不需要过滤字段类型
    data.ruleForm.leadsFieldList = fieldList || [];
  }

  // 过滤附件 & 引用附件
  data.ruleForm.leadsFieldList = data.ruleForm.leadsFieldList.filter((v) => v.fieldType !== 18 && !(v.fieldType === 21 && v.business?.fieldType === 18));

  // 过滤日期范围字段
  if (isFilterDateRange) {
    data.ruleForm.leadsFieldList = data.ruleForm.leadsFieldList.filter((v) => v.fieldType !== 9);
  }

  // 遍历每个字段并处理
  data.ruleForm.leadsFieldList.forEach((item, index) => {
    item.childSetting = item.settings;

    // 处理字段扩展
    if (item.fieldType === 10) {
      item.fieldExt = replaceIsEnabled(item.fieldExt);
    } else if (item?.business?.fieldType === 10) {
      item.business.fieldExt = replaceIsEnabled(item.business?.fieldExt);
    }

    // 拆分日期范围字段
    if (item.fieldType === 27) {
      // 子表单字段
      item?.childSetting?.forEach((k, kIndex) => {
        data.ruleForm.filterType[`${item.fieldKey}.${k.fieldKey}`] = k;
        allSearchFieldsList.value.push({
          ...k,
          key: `0-${index}-${kIndex}`,
          fieldName: `${item.fieldName}.${k.fieldName}`,
          label: `${item.fieldName}.${k.fieldName}`,
          value: `${item.fieldKey}.${k.fieldKey}`,
          arr: [`${item.fieldKey}.${k.fieldKey}`]
        });
        // 如果子字段为日期范围类型，也添加开始/结束时间
        if (k.fieldType === 9 && props.needSplitDateRange) {
          [dateRangStart, dateRangEnd].forEach((type, idx) => {
            allSearchFieldsList.value.push({
              ...k,
              key: `0-${index}-${kIndex}-${idx + 1}`,
              label: `${item.fieldName}.${k.fieldName}-${type === dateRangStart ? '开始时间' : '结束时间'}`,
              fieldName: `${item.fieldName}.${k.fieldName}-${type === dateRangStart ? '开始时间' : '结束时间'}`,
              value: `${item.fieldKey}.${k.fieldKey}-${type}`,
              fieldKey: `${item.fieldKey}.${k.fieldKey}-${type}`,
              subProperty: type === dateRangStart ? 'begin' : 'end',
              arr: [`${item.fieldKey}.${k.fieldKey}-${type}`]
            });
          });
        }
      });
    } else {
      data.ruleForm.filterType[item.fieldKey] = item;
      allSearchFieldsList.value.push({
        ...item,
        key: `0-${index}`,
        label: item.fieldName,
        value: item.fieldKey
      });

      if (item.fieldType === 9 && props.needSplitDateRange) {
        [dateRangStart, dateRangEnd].forEach((type, idx) => {
          allSearchFieldsList.value.push({
            ...item,
            key: `0-${index}-${idx + 1}`,
            label: `${item.fieldName}.${type === dateRangStart ? '开始时间' : '结束时间'}`,
            fieldName: `${item.fieldName}.${type === dateRangStart ? '开始时间' : '结束时间'}`,
            fieldKey: `${item.fieldKey}-${type}`,
            value: `${item.fieldKey}-${type}`,
            subProperty: type === dateRangStart ? 'begin' : 'end'
          });
        });
      }
    }

    // item.key = `0-${index}`;
    // item.subFieldKey = item.fieldKey;
    // item.setFieldName = item.fieldName;
    // item.arr = [];
    // item.childSetting = item.settings || [];

    // // 特殊处理27类型字段
    // if (item.fieldType === 27) {
    //   item.disabled = true;
    //   item?.childSetting?.forEach((k, kIndex) => {
    //     k.key = `0-${index}-${kIndex}`;
    //     k.subFieldKey = `${item.fieldKey}.${k.fieldKey}`;
    //     k.setFieldName = `${item.fieldName}.${k.fieldName}`;
    //     data.ruleForm.filterType[`${item.fieldKey}.${k.fieldKey}`] = k;
    //     item.arr.push(`${item.fieldKey}.${k.fieldKey}`);
    //   });
    // } else {
    //   data.ruleForm.filterType[item.fieldKey] = item;
    // }
  });
  allSearchFieldsList.value = moveTypeOneToEnd(allSearchFieldsList.value);
  await getFieldTypeCondition();
};

//获取字段列表
const getFieldList = async () => {
  let res = {};

  if (props.chartId) {
    //图表用新接口
    res = await biService.getEntityField({ entityType: entityId.value, chartId: props?.chartId || null });
    // 过滤 关联对象名称 关联对象数据
    res.result.fields = res.result?.fields?.filter((v) => !props.ruleOutFieldKeys.includes(v.fieldKey));

    // 过滤生命状态字段的 已作废
    filterStatus(res.result.fields);
  } else {
    const params = { entity: entityId.value, apiIndex: Math.random() };
    if (gettempSettingIds()) {
      params.tempSettingIds = gettempSettingIds();
    }
    if (gettempDisableSettingIds()) {
      params.tempDisableSettingIds = gettempDisableSettingIds() || '';
    }

    // 请求不带ext信息的字段
    res = await conditionStore.getEntityFieldsList(params);

    // 过滤 关联对象名称 关联对象数据
    res.result = res.result.filter((v) => v.fieldKey != 'businessId');
    // 过滤生命状态字段的 已作废
    filterStatus(res.result);
  }
  // 需要过滤字段类型
  handleFieldList(res.result);
};

//追加字段方法
const addFieldSetting = (conditionItem) => {
  //兼容清空首个选项
  if (!conditionItem?.field) return false;

  const fieldObj = allSearchFieldsList.value?.find((sub) => sub?.fieldKey == conditionItem.field || sub.arr?.includes(conditionItem.field));
  // 如果 fieldObj 有 childSetting，查找匹配的子项

  conditionItem.setting = fieldObj;

  if (fieldObj.childSetting?.length) {
    const childSetting = fieldObj.childSetting.find((m) => conditionItem.field?.split('.')?.[1] == m.fieldKey);

    // 如果找到匹配的子项，更新 el.setting
    if (childSetting) {
      conditionItem.setting = childSetting;
    }
  }
};

// 追加字段属性
const setConditionsFieldSetting = (conditionArray) => {
  conditionArray?.forEach((item) => {
    item?.children?.forEach((el) => {
      // 查找匹配的字段对象
      if (['begin', 'end'].includes(el.subProperty)) {
        // 有日期范围拆分的字段
        if (el.remark) {
          // 子表单日期范围特殊处理
          const remarkField = tools.isJSON(el.remark) ? JSON.parse(el.remark) : {};
          el.field = `${el.field}.${remarkField.fieldKey}-${el.subProperty === 'begin' ? '@@@@start' : '@@@@end'}`;
        } else {
          el.field = `${el.field}-${el.subProperty === 'begin' ? '@@@@start' : '@@@@end'}`;
        }
      }
      const fieldObj = allSearchFieldsList.value?.find((sub) => {
        return sub?.fieldKey == el.field || sub.arr?.includes(el.field);
      });
      if (!fieldObj || el.setting) {
        // 如果没有找到对应的 fieldObj 或者已经存在setting信息，跳过当前 el
        return;
      }

      addFieldSetting(el, fieldObj);
    });
  });
  console.log('追加setting222', JSON.parse(JSON.stringify(conditionArray)));
};

// 获取单个字段的fieldExt
const fetchFieldExtData = async (field) => {
  try {
    field.loading = true; // 开始加载时设置为true
    const fieldExtData = await getExtInfo(field);
    if (fieldExtData) {
      if (field?.setting?.fieldType == 21) {
        field.setting.fieldExt = fieldExtData?.fieldExt;
        field.setting.business = fieldExtData?.business;
      } else {
        field.setting.fieldExt = fieldExtData?.fieldExt;
      }
    }
  } catch (err) {
    console.error(`无法获取 ${field.field}的fieldExt`, err);
  } finally {
    field.loading = false; // 请求完成后设置为false
  }
};

// 人员部门
const isUserDepartment = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 6 || child.setting?.business?.fieldType === 6 || child.setting.fieldType === 22 || child.setting?.business?.fieldType === 22) {
    return true;
  } else {
    return false;
  }
};

// 级联
const isCascader = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 10 || child.setting?.business?.fieldType === 10) {
    return true;
  } else {
    return false;
  }
};

// 日期 日期区间
const isDteTime = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 8 || child.setting?.business?.fieldType === 8 || child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [8]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [8]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 日期区间
const isDateRange = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 9 || child.setting?.business?.fieldType === 9) {
    return true;
  } else {
    return false;
  }
};

// 数字
const isNumber = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 7 || child.setting?.business?.fieldType === 7 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [5, 7]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 金额
const isPrice = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 16 || child.setting?.business?.fieldType === 16 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [6, 16]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};
// 百分比
const isPercentage = (child) => {
  if (!child?.setting) return false;
  if (child.setting.fieldType === 23 || child.setting?.business?.fieldType === 23 || (child.setting.fieldType == 24 && tools.isJSON(child.setting.fieldExt) && [23]?.includes(JSON.parse(child.setting.fieldExt).type)) || (child.setting?.business?.fieldType == 24 && tools.isJSON(child.setting?.business?.fieldExt) && [23]?.includes(JSON.parse(child.setting?.business?.fieldExt).type))) {
    return true;
  } else {
    return false;
  }
};

// 获取条件
const getConditions = async () => {
  try {
    const conditions = JSON.parse(JSON.stringify(conditionsData.value));
    // 没有条件
    if (!conditions || conditions.length == 0) {
      if (props.showDefaultCondition) {
        // 高级筛选默认展示一条搜索项
        data.ruleForm.conditions = [{ id: undefined, parentId: undefined, operation: 'and', field: '', fieldType: '', value: null, isGroup: true, children: [{ id: undefined, parentId: undefined, field: '', fieldType: '', operation: '', value: null, isGroup: false }] }];
        data.ruleForm.fieldKey = t('全部数据');
        nextTick(() => {
          // setLoading(false);
          visibleMap.value['0-0'] = true;
        });
      }
    } else {
      const excludedFieldTypes = [0, 1, 11, 26];
      const fetchFieldExtPromises = [];
      conditions?.forEach((item) => {
        item.children?.forEach((sub) => {
          const remarkFieldKey = sub?.remark && tools.isJSON(sub.remark) ? JSON.parse(sub.remark)?.fieldKey : '';
          if (remarkFieldKey) {
            //子表单日期范围特殊处理
            sub.field = !sub.subProperty ? `${sub.field}.${remarkFieldKey}` : sub.field;
            const fieldObj = allSearchFieldsList.value?.find((k) => k?.fieldKey === sub.field || k.arr?.includes(sub.field));
            if (fieldObj) {
              sub.setting = fieldObj.childSetting?.find((m) => sub.field.split('.')[1] === m.fieldKey) || fieldObj;
            }
          }

          if (sub.setting?.id && !excludedFieldTypes.includes(sub.setting.fieldType)) {
            fetchFieldExtPromises.push(fetchFieldExtData(sub));
          }
        });
      });
      await Promise.all(fetchFieldExtPromises);

      console.log('初始化条件333', JSON.parse(JSON.stringify(conditions)));

      conditions?.forEach((item) => {
        item.children?.forEach((sub) => {
          if (isUserDepartment(sub) && (sub.operation != 'null' || sub.operation != 'not_null')) {
            sub.value = _.isString(sub.value) && sub?.business && Object.keys(sub?.business)?.length > 0 ? sub.business : sub.value;
            if (_.isString(sub.value) || _.isArray(sub.value)) {
              return false;
            }
            const dept = sub.value?.departIds?.map((v) => v.name) || [];
            const user = sub.value?.userIds?.map((v) => v.name) || [];
            const userIds = sub.value?.userIds?.map((v) => v.id || []);
            const departIds = sub.value?.departIds?.map((v) => v.id || []);
            sub.userDept = [...dept, ...user];
            if (userIds) sub.userDeptIds = [...userIds];
            if (departIds) sub.userDeptIds = [...departIds];
            sub.userList = sub.value?.userIds?.map((v) => {
              return {
                ...v,
                userName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.departList = sub.value?.departIds?.map((v) => {
              return {
                ...v,
                departmentName: v.name,
                avatarOrigin: v.avatar
              };
            });
            sub.value = JSON.stringify({
              userIds: userIds,
              departIds: departIds
            });
            sub.business = null;
          }
          if (sub.operation === 'in' || sub.operation === 'not_in') {
            if (_.isString(sub.value)) {
              if (isCascader(sub) && sub.value?.includes('/')) {
                sub.value = sub.value?.split(',')?.map((str) => str?.split('/'));
              } else {
                sub.value = sub?.value?.split(',');
              }
            }
          } else if (props.fromPage === 'formula' && sub.operation === 'between') {
            // 在区间（日期类型）
            if (isDteTime(sub)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              const datesArray = [parsedObject.beginDate, parsedObject.endDate];
              sub.value = datesArray;
            }
          } else if (isCascader(sub) && (sub.operation == 'equals' || sub.operation == 'not_equals')) {
            sub.value = sub.value && typeof sub.value === 'string' ? sub.value?.split('/') : sub?.value;
          } else if (sub.operation === 'between') {
            // 日期范围不包括日期范围拆分日期字段在区间
            if (isDateRange(sub) && !['begin', 'end'].includes(sub.subProperty)) {
              const parsedObject = tools.isJSON(sub.value) && JSON.parse(sub.value) ? JSON.parse(sub.value) : '';
              const datesArray = [parsedObject.beginDate, parsedObject.endDate];
              sub.value = datesArray;
            }
          } else {
            // 兼容一下日期类型的数据，如果返回的是数组就变成字符串
            sub.value = Array.isArray(sub.value) ? sub.value?.join() : sub.value;
          }
          // 处理数字
          if (isNumber(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value);
          }
          // 处理价格
          if (isPrice(sub) && sub.operation !== 'null' && sub.operation !== 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) sub.value = Number(sub.value) / 10000;
          }
          // 处理百分比字段类型
          if (isPercentage(sub) && sub.operation != 'null' && sub.operation != 'not_null') {
            if (sub.value && !isNaN(Number(sub.value))) {
              let fieldExt = '';
              if (sub.setting.fieldType === 21) {
                if (sub.setting?.business?.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.business?.fieldExt) && JSON.parse(sub.setting?.business?.fieldExt)?.numberFormat) || 2;
                }
              } else {
                if (sub.setting.fieldType === 24) {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.dataType) || 2;
                } else {
                  fieldExt = (tools.isJSON(sub.setting?.fieldExt) && JSON.parse(sub.setting?.fieldExt)?.numberFormat) || 2;
                }
              }
              sub.value = tools.getPercentage(sub.value, fieldExt);
            }
          }
        });
      });
      setLoading(false);

      data.ruleForm.conditions = conditions;
      // 回显数据
    }
  } catch (error) {
    console.log(error);
  }
  setLoading(false);
  isFirstFlag.value = true;
};

//数据选中事件
const condition = async () => {
  if (data.ruleForm?.conditions?.length < 1) {
    data.ruleForm.fieldKey = t('全部数据');
  } else if (data.ruleForm?.conditions?.length < 2) {
    data.ruleForm.fieldKey = '筛选 ·' + ' ' + data.fieldOne + ' ' + data.fieldTwo + ' ' + data.fieldThree;
  } else {
    data.ruleForm.fieldKey = '筛选 ·' + ' ' + data.ruleForm?.conditions?.length;
  }
};
// 人员配置
const userTree = ref({
  checkDepartment: false,
  isAll: false
});

console.log('人员配置', userTree.value);

// 部门配置
const departTree = ref({
  checkDepartment: true,
  isAll: false,
  data: [], // 数组 必传
  checkUser: false
});

// 初始化条件
const initialCondition = async () => {
  if (props.showDefaultCondition || conditionsData.value.length > 0) {
    setLoading(true);
  }

  if (!entityId.value) {
    data.ruleForm.conditions = [];
    data.ruleForm.leadsFieldList = [];
    allSearchFieldsList.value = [];
    data.lastEntityId = '';
    setLoading(false);
    return;
  }
  await getFieldList();
  setConditionsFieldSetting(conditionsData.value);
  setTimeout(async () => {
    await getConditions();
    await condition();
  }, 500);
};

watch(
  () => entityId.value,
  () => {
    initialCondition();
  },
  {
    deep: true,
    immediate: true
  }
);

const validateForm = async () => {
  const errors = await editAddForm.value?.validate?.();
  if (errors) {
    // 校验失败
    return false;
  }
  return true;
};

const formValidateFn = (cIndex, vIndex, field) => {
  editAddForm.value?.setFields?.({
    [`conditions.${cIndex}.children.${vIndex}.${field}`]: {
      status: 'error',
      message: ''
    }
  });
};

// 校验表单
const personError = ref({});

const formValidate = async () => {
  const conditionResult = updateCondition();
  let error = true;
  let firstErrorField = null;
  conditionResult.forEach((cItem, cIndex) => {
    cItem.children?.forEach((vItem, vIndex) => {
      const storeFirstError = (field) => {
        if (!firstErrorField) {
          firstErrorField = `conditions.${cIndex}.children.${vIndex}.${field}`;
        }
      };

      if (!vItem.field) {
        formValidateFn(cIndex, vIndex, 'field');
        storeFirstError('field');
        error = false;
      }
      if (!vItem.operation) {
        formValidateFn(cIndex, vIndex, 'operation');
        storeFirstError('operation');
        error = false;
      }
      if (vItem.operation !== 'null' && vItem.operation !== 'not_null') {
        if ([6, 22].includes(vItem.fieldType)) {
          console.log('部门人员测试', vItem);
          if (!vItem?.userDept?.length) {
            personError.value[`${cIndex}-${vIndex}`] = true;
            formValidateFn(cIndex, vIndex, 'value');
            storeFirstError('value');
            error = false;
          }
        } else {
          if (!vItem.value && vItem.value !== 0) {
            formValidateFn(cIndex, vIndex, 'value');
            storeFirstError('value');
            error = false;
          }
        }
      }
    });
  });

  if (firstErrorField) {
    console.log('firstErrorField', firstErrorField);
    nextTick(() => {
      editAddForm.value?.scrollToField?.(firstErrorField);
    });
  }
  const validate = await validateForm();
  console.log('校验结果333', validate, error);
  return error && validate;
};

//确认请求
const getAllConditions = async (isRequired = true) => {
  if (isRequired) {
    // 是否校验必填
    const error = await formValidate();
    if (!error) {
      // 校验失败
      Message.warning('请完善筛选条件');
      return false;
    }
  }
  return updateCondition();
};

const clearAllCondition = () => {
  data.ruleForm.conditions = [];
  emits('clearAll', []);
};

//按钮提交
const searchSubmit = async () => {
  const conditions = await getAllConditions();
  if (!conditions) return;
  emits('submit', conditions);
};

// 获取条件
// const getCondition = () => {
//   return updateCondition();
// };

defineExpose({
  // getCondition,
  formValidate,
  getAllConditions
  // update
});

console.log(data, name);
</script>
<style scoped lang="less">
@import './custom-search-ultra.less';
</style>
<style lang="less">
.search-ultra-filter-select {
  &.field-select {
    min-width: 240px;
  }
}
</style>
